import { FormattedMessage } from 'react-intl'
import { TouchableWithoutFeedback, View } from 'react-native'
import styled from 'styled-components'
import { Icon } from '../../../elements/images/Icon/index.js'
import { Text } from '../../../elements/typography/index.js'
import { cursorPointer } from '../../../style/webStyles.js'
import messages from '../messages.js'

const ChangePlanButton = styled(View)`
  ${cursorPointer};
  flex-direction: row;
  align-items: center;
  align-self: center;
  margin-bottom: ${(props) => props.theme.spacing.large}px;
`

const ChangePlanText = styled(Text)`
  font-size: ${(props) => props.theme.fontSizes.small}px;
  margin-left: ${(props) => props.theme.spacing.small}px;
`

export const ChangePlanLink = ({ onRequestChange }) => (
  <TouchableWithoutFeedback onPress={onRequestChange}>
    <ChangePlanButton>
      <Icon name="long-arrow-left" scale={0.5} />
      <ChangePlanText>
        <FormattedMessage {...messages.chooseDifferentPlan} />
      </ChangePlanText>
    </ChangePlanButton>
  </TouchableWithoutFeedback>
)
